<template>
  <v-container id="register" class="fill-height justify-center" tag="section">
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card color="secondary" light max-width="100%" width="800">
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-2">
                {{ $t("register") }}
              </h1>
            </div>
          </template>

          <v-row>
            <v-col cols="12" md="6" v-if="$vuetify.breakpoint.mdAndUp">
              <v-row no-gutters>
                <v-col v-for="(section, i) in sections" :key="i" cols="12">
                  <v-list-item three-line>
                    <v-list-item-icon class="mr-4 mt-5 mt-md-4">
                      <v-icon :large="$vuetify.breakpoint.mdAndUp" :color="section.iconColor" v-text="section.icon" />
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title class="font-weight-light mb-4 mt-3" v-text="section.title" />

                      <v-list-item-subtitle v-text="section.text" />
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="6">
              <form action="javascript:void(0);" v-on:submit="register">
                <div class="text-center">
                  <div class="my-2" />

                  <v-text-field color="secondary" :rules="required" v-model="name" :label="$t('name')"
                    prepend-icon="mdi-face" />
                  <v-text-field color="secondary" :rules="required" v-model="surname" :label="$t('surname')"
                    prepend-icon="mdi-face" />

                  <v-text-field color="secondary" :rules="requiredEmail" v-model="email" :label="$t('email')"
                    prepend-icon="mdi-email" />

                  <v-text-field v-if="registerCfisc" v-model="cFiscale" :label="$t('fiscal_code')" hide-details="auto"
                    :rules="required" prepend-icon="mdi-card-account-details-outline" />

                  <br />
                  <br />
                  <v-checkbox v-model="boolean" :input-value="true" color="secondary">
                    <template v-slot:label>
                      <span class="text-no-wrap">{{ $t("i_agree_to") }}&nbsp;&nbsp;</span>

                      <span class="terms text-no-wrap">
                        <a class="secondary--text ml-6 ml-sm-0" href="#">{{
                          $t("terms_and_conditions")
                        }}</a>.
                      </span>
                    </template>
                  </v-checkbox>

                  <v-btn color="success" depressed type="submit" class="v-btn--text" style="float: right">{{
                    $t("register") }}</v-btn>
                </div>
              </form>
            </v-col>
          </v-row>
          <p slot="error" class="text-danger">{{ message }}</p>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
import { load } from "recaptcha-v3";
import Swal from "sweetalert2";

export default {
  name: "PagesRegister",

  components: {
    PagesBtn: () => import("./components/Btn"),
    PagesHeading: () => import("./components/Heading"),
  },
  computed: {
    registerCfisc: function () {
      if (
        window.systemData &&
        window.systemData.SYSTEM &&
        window.systemData.SYSTEM.disable_cfisc_on_register &&
        window.systemData.SYSTEM.disable_cfisc_on_register === "1"
      )
        return false;
      else return true;
    },
  },
  data: () => ({
    name: null,
    surname: null,
    message: null,
    cFiscale: null,
    boolean: false,
    email: null,
    recaptcha: null,
    required: [(value) => !!value || "campo obbligatorio"],
    requiredEmail: [
      (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail must be valid",
    ],
    sections: [],
  }),
  mounted() {
    let _ = this;
    _.sections = [
      {
        icon: "mdi-lead-pencil",
        iconColor: "cyan",
        title: _.$t("insert_your_data"),
        text: _.$t("insert_your_registration_data"),
      },
      {
        icon: "mdi-book-open",
        iconColor: "secondary",
        title: _.$t("read_the_condition"),
        text: _.$t("read_the_condition_and_accept"),
      },
      {
        icon: "mdi-email-check-outline",
        iconColor: "success",
        title: _.$t("confirm_registration_and_set_password"),
        text: _.$t("check_email_and_follow_link"),
      },
    ];
  },
  methods: {
    register: async function (event) {
      let _ = this;
      if (!_.boolean) {
        Swal.fire({
          title: _.$t("it_s_mandatory_to_accept_the_terms"),
          html: _.$t("please_read_the_terms_and_agree_with_confirm_button"),
        });
        return;
      }
      let params = {
        email: _.email,
        name: _.name,
        surname: _.surname,
        cFiscale: _.cFiscale,
      };
      try {
        if (window.systemData.RECAPTCHA !== "") {
          let recaptcha = await load(window.systemData.RECAPTCHA);
          let recaptchaToken = await recaptcha.execute("register");
          params["g-recaptcha-response"] = recaptchaToken;
        }
        let response = await this.chiamataAxios(
          "POST",
          "/recaptcha/portal/register",
          { body: params, dialogLoader: true, msg: "always" }
        );
      } catch (e) {
        Swal.fire({
          title: _.$t("registration_error"),
        });
      }
    },
  },
};
</script>

<style lang="sass" scoped>
#register
  .v-list-item__subtitle
    -webkic-line-clamp: initial
    -webkit-box-orient: initial
  .terms
    margin-left: 5px
</style>
